<template>
  <div class="speaker-components">
    <img :src="details.image" />
    <div class="bio">
      <div class="name">{{details.name}}</div>
      <div class="title">{{details.title}}</div>
      <truncate class="text" action-class="show-link" clamp="Show more" :length="750" less="Show Less" type="html" :text="details.bio" />
    </div>
  </div>
</template>
<script>
import Truncate from 'vue-truncate-collapsed'
export default {
  name: 'speaker-components',
  props: ['details'],
  components: { Truncate },
}
</script>
<style scoped lang="scss">
  .speaker-components {
    overflow: hidden;
    img {
      border-radius: 30px;
      box-sizing: border-box;
      width: 100%;
      padding: 15px;
    }
    .bio {
      margin: 15px;
      font-size: 22px;
    }
    .name {
      font-size: 25px;
      font-weight: bold;
      margin: 15px 0 5px 0;
    }
    .title {
      font-size: 20px;
      font-weight: bold;
      color: $color-1;
      margin-bottom: 20px;
    }
    /deep/ .show-link {
      color: $color-1;
    }
    .text {
      text-align: justify;
      color: #333;
    }
  }
  @media (min-width: 501px) {
    .speaker-components {
      overflow: hidden;
      img {
        border-radius: 30px;
        float: left;
        width: 400px;
      }
      .bio {
        float: left;
        margin: 0 0 0 40px;
        width: 840px;
        font-size: 22px;
      }
    }
  }
</style>
